import {
  FetchBreakSettingsDocument,
  UpdateBreakSettingDocument,
  UpdateBreakSettingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateAttendanceBreakSetting = () => {
  const [updateBreakSetting, { loading }] = useMutation(UpdateBreakSettingDocument, {
    extractorFn: (data) => data.attendanceMutations.updateAttendanceBreakSetting,
  })

  const update = (variables: UpdateBreakSettingMutationVariables) => {
    return updateBreakSetting({
      variables,
      refetchQueries: [FetchBreakSettingsDocument],
    })
  }

  return {
    loading,
    update,
  }
}
